"use client";
import { useEffect, useState } from "react";

// Check whether the mounted component is in dark or light mode
export function useMounted() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
}
